import { Project } from "src/app/models/project";

export const SOCIAL_NETWORKS = {
    github: {
        label: 'Github',
        url: 'https://github.com/Andgvo?tab=repositories'
    },
    linkedin: {
        label: 'Linkedin',
        url: 'https://mx.linkedin.com/in/gustavo-andr%C3%A9s-l%C3%B3pez-s%C3%A1nchez-9b39a1205'
    },

};

export const SKILS = [
    { name: 'Android', icon:'devicon-android-plain ', desc:'Java y kotlin' },
    { name: 'iOS', icon:'devicon-apple-original', desc:'Storyboards y SwiftUI' },
    { name: 'Angular', icon:'devicon-angularjs-plain', desc:'HTML, CSS y Typescript' },
    { name: 'React', icon:'devicon-react-original', desc:'HTML, CSS y Typescript' },
    { name: 'Java', icon:'devicon-java-plain', desc:'Spring Boot y Selenium' },
    { name: 'Express', icon:'devicon-express-original', desc:'Backend, JWT, etc.' },
    { name: 'Firebase', icon:'devicon-firebase-plain', desc:'Firestore y Hosting' },
    { name: 'Mongo', icon:'devicon-mongodb-plain', desc:'' },
    { name: 'MySQL', icon:'devicon-mysql-plain', desc:'' },
    { name: 'Postgres', icon:'devicon-postgresql-plain', desc:'' },
]

export const PORTFOLIO:Project[] = [
    new Project('Vive Tu Futuro','Bandera corporativa', 'assets/img/portfolio/viveTuFuturo.svg'),
    new Project('Grupo Salinas','Banderín corporativo', 'assets/img/portfolio/gs.svg'),
    new Project('Instituto Politécnico nacional','Bandera con escudo', 'assets/img/portfolio/ipn.svg'),
    new Project('Angular Bootstrap Template','Bandera con escudo', 'assets/img/portfolio/bootstrap-angular.jpg')
];